import "htmx.org";

// Morph keeps the cells, so the fade does not run again unless
// row-saved is removed and restored after a style flush.
document.addEventListener("htmx:after:swap", (event: Event) => {
  if (!(event instanceof CustomEvent)) return;
  const target = event.detail?.ctx?.target;
  if (!(target instanceof Element)) return;
  const saved = [
    ...(target.classList.contains("row-saved") ? [target] : []),
    ...target.querySelectorAll(".row-saved"),
  ];
  for (const row of saved) {
    row.classList.remove("row-saved");
    void (row as HTMLElement).offsetWidth;
    row.classList.add("row-saved");
  }
});
